import React, { useEffect, useState } from "react";
import "./BenefitsSection.scss";
import Button from "./Buttons/Button";
import { getBenefitBySubcategoryId } from "../services/getBenefitBySubcategoryId";
import { ImageLink } from "../constants";

const BenefitsSection = ({
  subCategoryId,
  id = "",
  setIsModelOpen = () => {},
  btnDisabled = false,
  title = "",
  description = "",
  btnText = "",
}) => {
  const [pageData, setPageData] = useState([]);
  const fetchData = async () => {
    await getBenefitBySubcategoryId({
      subCategoryId,
    })
      .then((data) => {
        setPageData(data.data);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (!pageData?.benefitData?.length) {
    return null;
  }

  return (
    <div className="container">
      <div className="benefits-section-wrapper">
        <div className="benefits-section-container">
          <h3 className="title">
            {pageData?.mainTitle ?? "What Makes DoubtQ Different?"}
          </h3>
          <div className="description">
            {description ||
              "Smart academic support designed around student needs."}
          </div>
        </div>
        <div className="benefits-card-wrapper">
          {pageData?.benefitData?.map((e, index) => {
            return <BenfitCard key={index} {...e} />;
          })}
        </div>
        {!btnDisabled ? (
          <Button
            text={btnText || "Explore Our Advantage "}
            varient="primary"
            onClick={() => setIsModelOpen(true)}
          ></Button>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

const BenfitCard = ({ title = "", description = "", image = "" }) => {
  return (
    <div className="benefits-card-container">
      <div className="benefits-card-icon">
        <img src={ImageLink(image)} alt="" />
      </div>
      <h3 className="benefits-card-title">{title}</h3>
      <div className="benefits-card-description">{description}</div>
    </div>
  );
};

export default BenefitsSection;
